import React, { Component } from 'react';

export const EditLink = ({id}) => {
  return(
    <div className="media-right">
      <a href={`/pro/walk_ins/${id}/edit`}>
        Edit <i className="fa fa-pencil" aria-hidden="true"></i>
      </a>
    </div>
  )

}

export default EditLink
